import $ from "jquery";
import { smoothscroll } from "../utils/smoothscroll";
import { debounce } from "../utils/functions";

const $boardListEl = $(".board-insight");

$(function () {
  if ($boardListEl.length > 0) {
    $boardListEl.each(function () {
      boardList($(this));
    });
  }
});

const boardList = (listEl) => {
  const filter = {
    limit: listEl.data("limit"),
    category: "",
    search: "",
    lang: listEl.data("lang"),
  };

  bindBoardFilter(listEl, filter);
};

const reRenderList = async (element, filter, scrollTop = false) => {
  const data = await getBoards(filter);
  element.find(".board-insight__content").html(data.html);

  if (scrollTop === true) {
    smoothscroll(element, "header");
  }
};

const bindBoardFilter = (element, filter) => {
  element.on("click", ".board-filter__item", function () {
    const $thisEl = $(this);
    $(".board-filter__item.selected").removeClass("selected");
    $thisEl.addClass("selected");

    filter.category = $thisEl.data("id");
    reRenderList(element, filter);
  });

  element.on(
    "input",
    "input[name='board-filter-input-search']",
    debounce(function () {
      const $input = $(this);
      filter.search = $input.val();

      if (filter.search) {
        $input.parent().addClass("has-value");
      } else {
        $input.parent().removeClass("has-value");
      }
      reRenderList(element, filter);
    })
  );

  element.on("click", "button[name='board-filter-input-reset']", function () {
    element
      .find("input[name='board-filter-input-search']")
      .val("")
      .trigger("input");
  });
};

const getBoards = async (filter) => {
  try {
    const response = await fetch(
      SITE_PARAMS.site_url + "/wp-json/malacky/v1/board-insight/html",
      {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(filter),
      }
    );
    const result = await response.json();
    return result;
  } catch (e) {
    console.log(e);
    return null;
  }
};
